module.exports = __webpack_public_path__ + "img/symbol_0.974c7f68.png";